export class PersonModel {
  public id = 0;
  public lastName = '';
  public firstName = '';
  public dateOfBirth?: String;
  public placeOfBirth?: String;
  public dateOfDeath?: String;
  public placeOfDeath?: String;
  public sex?: String;

  constructor() {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: PersonModel[] = [];
    jsons.forEach(json => {
      refs.push(new PersonModel().fromJSON(json));
    });
    return refs;
  }
}
